import { createContext, useCallback, useContext, useState } from "react";
import JoinModal from "@/components/landing/JoinModal";

const JoinModalContext = createContext({ open: () => {}, close: () => {} });

export const useJoinModal = () => useContext(JoinModalContext);

export default function JoinModalProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false);
    const [ctx, setCtx] = useState({});

    const open = useCallback((opts = {}) => {
        setCtx(opts && typeof opts === "object" ? opts : {});
        setIsOpen(true);
    }, []);

    const close = useCallback(() => {
        setIsOpen(false);
        setTimeout(() => setCtx({}), 350);
    }, []);

    return (
        <JoinModalContext.Provider value={{ open, close }}>
            {children}
            <JoinModal
                open={isOpen}
                onOpenChange={(v) => (v ? setIsOpen(true) : close())}
                lumaEventUrl={ctx.lumaEventUrl}
                lumaEventName={ctx.lumaEventName}
            />
        </JoinModalContext.Provider>
    );
}
